import Vue from "vue"
import Vuex from "vuex"
import Http from "@shared/lib/Http"
import { MessageBox, Message, Notification } from "element-ui"
import moment from "moment"

Vue.use(Vuex)

const $tenant = Http

const rand = (min, max) => Math.random() * (max - min) + min

// prettier-ignore
// const demoPosts = (count = 50) => {
//   let posts = [], item = {
//     id: null,
//     date: (new Date()).toUTCString(),
//     name: 'Test Post',
//     content: '',
//     tags: ['TAG A', 'TAG B']
//   }

//   for (let i = 0; i < count; i++) {
//     const date = moment().subtract(rand(0, 30), 'days').toString()
//     posts.push(Object.assign(_.clone(item), {
//       id: `post-${i}`,
//       date,
//       name: `Test Post #${i}`,
//       content: ('<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Excepturi commodi natus at id.</p>').repeat(rand(1, 10))
//     }))
//   }

//   return posts
// }

const store = new Vuex.Store({
    state: {
        isLoading: false,
        openPostsMenu: false,
        height: {},
        vueScrollOptions: { bar: { background: "#ddd" } },

        posts: [],
        activePostId: null,
        hidePost: false,
        relativeMenuPosition: true

        // scrollableHeight: null
    },

    getters: {
        vueScrollOptions: state => state.vueScrollOptions,

        height: state => state.height,

        notificationsGroupedByDate: (state, getters) => {
            return _.chain(state.posts)
                .groupBy(e => {
                    return moment(e.notification.date).format("DD/MM/YYYY")
                })
                .value()
        },

        notifications: (state, getters) => {
            return state.posts
        },

        activePost: (state, getters) => {
            state.activePostId = _.get(getters.notifications.find(notification => notification.read == 0), 'id', state.activePostId)
            // console.log("activePostId", state.activePostId)
            return getters.notifications.find((post, i) => post.id === state.activePostId)
        },

        readCount: (state, getters) => {
            return _.size(getters.notifications.filter(e => _.get(e, 'read') === 1))
        },

        unreadCount: (state, getters) => {
            return _.size(getters.notifications.filter(e => _.get(e, 'read') === 0))
        }
    },

    mutations: {
        openPostsMenu(state, value) {
            state.openPostsMenu = value
        },

        setNotifications(state, value) {
            // state.notifications = value
            state.posts = value
        },

        hidePost(state, value) {
            state.hidePost = value
        }
    },

    actions: {
        setHeight({ commit, state }, { name, height }) {
            state.height = { ...state.height, ...{ [name]: height } }
        },

        openPostsMenu({ commit, state }, value) {
            commit("openPostsMenu", value)
        },

        // hidePost({ commit, state }, value) {
        //   state.hidePost = value
        // },

        async markAsRead({ commit, state }, notification) {
            console.log("markAsRead", notification)
            if (!notification) return false

            const id = notification.id

            state.hidePost = true

            const { data, status } = axios.post(`/api/v3/support/notifications/markAsRead/${id}`)
            state.posts = state.posts.map(e => (e.id === id ? Object.assign(e, { read: 1 }) : e))

            setTimeout(() => {
                state.hidePost = false
                state.activePostId = id
            }, 250)
        },

        async fetchNotifications({ commit, state }) {
            state.isLoading = true
            setTimeout(() => (state.isLoading = false), 5000)

            const { data, status } = await axios.get("/api/v3/support/notifications", {
                params: {
                    // page: state.currentPage,
                    // count: state.perPageCount
                }
            })
            let { notification, read } = data

            let notifications = data.map((e) => {
                // prettier-ignore
                if (_.get(e, "notification.date")) {
                    e.notification.date = moment(`${e.notification.date}z`).local().toDate()
                    return e
                }
            })
            commit("setNotifications", notifications)

            state.isLoading = false
        }
    }
})

export default store
